/**
 * WCAG-Compliant Keyboard Navigation for Reformation Theme
 * Targets: .thb-full-menu structure with mega menus
 */

(function() {
  'use strict';

  class ReformationMenuKeyboardNav {
    constructor() {
      this.init();
    }

    init() {
      const mainMenu = document.querySelector('.thb-full-menu[role="menubar"]');
      if (!mainMenu) return;

      const topLevelItems = Array.from(mainMenu.querySelectorAll(':scope > li[role="menuitem"]'));
      
      topLevelItems.forEach((item, index) => {
        const link = item.querySelector(':scope > a, :scope > button');
        const submenu = item.querySelector(':scope > .sub-menu, :scope > .mega-menu-container');
        
        if (link) {
          link.addEventListener('keydown', (e) => {
            this.handleTopLevelKeyDown(e, topLevelItems, index, link, submenu);
          });

          // Setup submenu items if they exist
          if (submenu) {
            this.setupSubmenu(submenu, link);
          }
        }
      });
    }

    handleTopLevelKeyDown(event, items, currentIndex, link, submenu) {
      const key = event.key;

      switch(key) {
        case 'ArrowRight':
          event.preventDefault();
          // Move to next top-level item
          const nextIndex = (currentIndex + 1) % items.length;
          const nextLink = items[nextIndex].querySelector(':scope > a, :scope > button');
          if (nextLink) nextLink.focus();
          break;

        case 'ArrowLeft':
          event.preventDefault();
          // Move to previous top-level item
          const prevIndex = currentIndex === 0 ? items.length - 1 : currentIndex - 1;
          const prevLink = items[prevIndex].querySelector(':scope > a, :scope > button');
          if (prevLink) prevLink.focus();
          break;

        case 'ArrowDown':
          event.preventDefault();
          if (submenu) {
            // Open submenu and focus first item
            link.parentElement.classList.add('is-open');
            const firstSubmenuLink = submenu.querySelector('a, button');
            if (firstSubmenuLink) firstSubmenuLink.focus();
          }
          break;

        case 'ArrowUp':
          event.preventDefault();
          if (submenu) {
            // Open submenu and focus last item
            link.parentElement.classList.add('is-open');
            const submenuLinks = Array.from(submenu.querySelectorAll('a, button'));
            if (submenuLinks.length) submenuLinks[submenuLinks.length - 1].focus();
          }
          break;

        case 'Escape':
          event.preventDefault();
          // Close any open submenus
          link.parentElement.classList.remove('is-open');
          link.focus();
          break;

        case 'Enter':
        case ' ':
          // If has submenu, toggle it; otherwise follow link
          if (submenu && event.key === ' ') {
            event.preventDefault();
            link.parentElement.classList.toggle('is-open');
          }
          break;
      }
    }

    setupSubmenu(submenu, parentLink) {
      const submenuLinks = Array.from(submenu.querySelectorAll('a, button'));
      
      submenuLinks.forEach((link, index) => {
        link.addEventListener('keydown', (e) => {
          this.handleSubmenuKeyDown(e, submenuLinks, index, parentLink, submenu);
        });
      });
    }

    handleSubmenuKeyDown(event, items, currentIndex, parentLink, submenu) {
      const key = event.key;

      switch(key) {
        case 'ArrowDown':
          event.preventDefault();
          // Move to next submenu item
          const nextIndex = (currentIndex + 1) % items.length;
          items[nextIndex].focus();
          break;

        case 'ArrowUp':
          event.preventDefault();
          // Move to previous submenu item
          const prevIndex = currentIndex === 0 ? items.length - 1 : currentIndex - 1;
          items[prevIndex].focus();
          break;

        case 'ArrowLeft':
        case 'Escape':
          event.preventDefault();
          // Close submenu and return to parent
          parentLink.parentElement.classList.remove('is-open');
          parentLink.focus();
          break;

        case 'Tab':
          // When tabbing out of last item, close submenu
          if (!event.shiftKey && currentIndex === items.length - 1) {
            setTimeout(() => {
              if (!submenu.contains(document.activeElement)) {
                parentLink.parentElement.classList.remove('is-open');
              }
            }, 0);
          }
          break;
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ReformationMenuKeyboardNav());
  } else {
    new ReformationMenuKeyboardNav();
  }
})();
